import { FC, useState } from "react";
import { IStudent } from "../../../models/students.model";
import StudentName from "./Name";
import styled from "styled-components";
import Button from "../../Button";
import { useTranslation } from "react-i18next";
import useAuth from "../../../hooks/useAuth";
import SchoolRecordTable from "./SchoolRecordTable";
import PublisherTable from "./PublisherTable";

const Block = styled.div`
  table {
    text-align: center;
  }
`;

interface IProps {
  student?: IStudent;
};

const StudentSchoolRecordPane: FC<IProps> = ({
  student,
}) => {
  const { writeAuthYn } = useAuth();
  const { t } = useTranslation();

  const [isEdit, setIsEdit] = useState(false);
  const [submitTrigger, setSubmitTrigger] = useState(false);

  const onClick = () => {
    if (isEdit) {
      setSubmitTrigger(current => !current);
    } else {
      setIsEdit(true);
    }
  };

  return (
    <Block>
      <StudentName
        student={student}
      />
      <SchoolRecordTable
        memberCode={student?.studentCode}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        submitTrigger={submitTrigger}
      />
      <PublisherTable
        student={student}
      />
      <div className="comm-bx__space">
        <div className="comm-btn__area right">
          <Button
            className={isEdit ? "btn-basic pink" : "btn-basic pink-line"}
            text={isEdit ? t('common.button.save') : t('common.button.edit')}
            onClick={onClick}
            writeAuthYn={writeAuthYn}
          />
        </div>
      </div>
    </Block>
  );
};

export default StudentSchoolRecordPane;